import { useState } from "react";
import { Paper, CircularProgress } from "@mui/material";

import MUIDataTable from "mui-datatables";

import "jspdf-autotable";
import { TableHead, TableRow, TableCell } from "@mui/material";
import useStore from "../../Hooks/useStore";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Tooltip,
} from "@mui/material";
function Datatable(props) {
  // For custom toolbar

  // console.log(props.data, "propsdata");
  const { setFetchAgain } = useStore();

  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const rows = props?.data || [];
  let debounceTimeout;
  const fetchSearchData = async (searchText) => {
    try {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(async () => {
        props.setSearchTerm(searchText);
        setFetchAgain((prev) => !prev);
        console.log("Searching for", searchText);
      }, [1000]);
    } catch (error) {
      console.log(error, "error");
    }
  };

  // console.log(rows, "rows");
  const options = {
    elevation: 0,
    filterType: "multiselect",
    selectableRows: "none",
    selectableRowsHeader: false,
    search: true,
    searchPlaceholder: props.searchPlaceholder || "Enter search key",
    searchAlwaysOpen: true,
    // hide default toolbar actions
    download: false,
    print: false,
    filter: false,
    viewColumns: false,
    onSearchChange: (searchText) => {
      // setSearchString(searchText); // Capture the search string
      // console.log("Search String:", searchText);

      fetchSearchData(searchText);
    },
    serverSide: true,
    // draggable: true,
    // draggableColumns: { enabled: true },
    page: props?.page,
    // fixedSelectColumn: true,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "calc(100vh - 225px)",
    // jumpToPage: true,
    // resizableColumns: true,
    rowsPerPage: props?.rowsPerPage,
    count: props?.totalCount,
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changePage":
          props.setPage(tableState.page);
          break;
        case "changeRowsPerPage":
          props.setRowsPerPage(tableState.rowsPerPage);
          props.setPage(0);
          break;
      }
    },
    textLabels: {
      body: {
        noMatch: props?.loading
          ? "Loading data..."
          : "Sorry, no matching records found",
      },
    },

    customToolbar: () => {

      if (props?.dealType === undefined) return <></>
      return (
        <FormControl size="small" variant="outlined" sx={{ minWidth: 170 }}>
          <InputLabel id="deal-type-label">TBD Deal</InputLabel>
          <Select
            labelId="deal-type-label"
            id="deal-type"
            value={props?.dealType}
            label="Deal Type"
            onChange={props?.handleDealTypeChange}
          >
            <MenuItem value={0}>All Deals</MenuItem>
            <MenuItem value={1}>AI Deals</MenuItem>
            <MenuItem value={2}>Manual Deals</MenuItem>
            <MenuItem value={3}>Custom Message</MenuItem>
          </Select>
        </FormControl>
      )
    }
  };

  return (
    <Paper elevation={3}>
      {/* Custom Toolbar */}

      <div
        style={{
          position: "relative",
          overflowY: "hidden",
          flex: 1,
          padding: "0 1.5rem",
        }}
      >
        <MUIDataTable
          key={`page-${props.page}`}
          className="m-3"
          data={rows}
          columns={props.columns}
          options={options}
          components={{
            TableHead: (props) => (
              <TableHead>
                <TableRow style={{ backgroundColor: "#e1effb" }}>
                  {props.columns.map((column, index) => (
                    <TableCell
                      key={index}
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                      }} // Customize text color and style
                    >
                      {column.label || column.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            ),
          }}
        />

        {props.loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(255,255,255,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 20,
              pointerEvents: "none",
            }}
          >
            <CircularProgress />
          </div>
        )}
      </div>
    </Paper>
  );
}

export default Datatable;
